import { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SuccessIcon, CloseIcon2 } from '@medeloop/medeloop-components-library';
import { selectToastState } from 'src/store/selectors';
import { ToastType, closeToast } from 'src/store/toast';

const selectToastStyle = function (type: ToastType): {
  icon: ReactNode;
  style: string;
} {
  if (type === 'success') {
    return {
      icon: <SuccessIcon className="w-4 text-green-400" />,
      style: 'bg-green-50 border-green-400',
    };
  }

  if (type === 'dangerous') {
    return {
      icon: <CloseIcon2 className="w-4 text-red-400" />,
      style: 'bg-red-50 border-red-400',
    };
  }

  return {
    icon: null,
    style: '',
  };
};

export function Toast() {
  const dispatch = useDispatch();
  const { message, type, show } = useSelector(selectToastState);

  const toastStyle = selectToastStyle(type);

  useEffect(() => {
    if (show) {
      setTimeout(() => {
        dispatch(closeToast());
      }, 3000);
    }
  }, [show]);

  return (
    <div
      className={`
        ${show ? 'flex' : 'hidden'}
        items-center gap-2 border-2 fixed z-[100] bottom-12
        left-2/4 -translate-x-2/4 text-sm py-2 px-4 rounded
        ${toastStyle.style}
    `}
    >
      {toastStyle.icon}
      {message}
    </div>
  );
}
